export default __webpack_public_path__ + "assets/burundi-flag.png";